/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/no-unknown-property */
/* eslint-disable @next/next/no-img-element */
import React, { useState } from 'react';
import Style from './OpenFinancePassoAPasso.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';

function OpenFinancePassoAPasso() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);
  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <>
      <section id="open-finance-passo-a-passo">
        <div className="open-finance-passo-a-passo-p1">
          <ContainerHome24>
            <div className="passo-a-passo-titulos">
              <h2 className="passo-a-passo-titulo">Passo a passo para enviar seus dados</h2>
              <p className="passo-a-passo-subtitulo">
                Apenas com uma proposta ou contrato com a Santander Financiamentos é possível
                realizar o Open Finance.
              </p>
            </div>
            <div className="passo-a-passo-itens">
              <p className="passo-a-passo-item">
                <b>1.</b> Acesse a instituição que deseja enviar os dados;
              </p>
              <p className="passo-a-passo-item">
                <b>2.</b> Escolha a Santander Financiamentos para seguir;
              </p>
              <p className="passo-a-passo-item">
                <b>3.</b> Selecione o prazo que o compartilhamento deverá ficar ativo;
              </p>
              <p className="passo-a-passo-item">
                <b>4.</b> Confirme e gerencie o consentimento na área logada do portal.
              </p>
            </div>
          </ContainerHome24>
          {typeof window === 'undefined' ? (
            <></>
          ) : (
            <>
              {width < 992 && (
                <img
                  src="assets/open-finance/passo-a-passo/img-passo-a-passo.svg"
                  alt=""
                  className="img-passo-a-passo"
                />
              )}
              {width >= 992 && (
                <img
                  src="assets/open-finance/passo-a-passo/img-passo-a-passo-desk.svg"
                  alt=""
                  className="img-passo-a-passo"
                />
              )}
            </>
          )}
        </div>
        <div className="open-finance-passo-a-passo-p2">
          <ContainerHome24>
            <div className="passo-a-passo-card">
              <img src="assets/open-finance/passo-a-passo/ic_circle_account_user_add.svg" alt="" />
              <p className="passo-a-passo-card-texto">
                Maior autonomia
                <br />
                com seus dados
              </p>
            </div>
            <div className="passo-a-passo-card">
              <img src="assets/open-finance/passo-a-passo/ic_security_verified.svg" alt="" />
              <p className="passo-a-passo-card-texto">
                Sigilo das informações
                <br />
                compartilhadas
              </p>
            </div>
            <div className="passo-a-passo-card">
              <img src="assets/open-finance/passo-a-passo/ic_terminal_code.svg" alt="" />
              <p className="passo-a-passo-card-texto">
                Dados criptografados
                <br />e 100% seguros
              </p>
            </div>
          </ContainerHome24>
        </div>
      </section>
      <style jsx>{Style}</style>
    </>
  );
}

export default OpenFinancePassoAPasso;
